import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { Col, Row, Modal, ModalHeader, ModalBody } from "reactstrap";
import { toast } from "react-toastify";
import DataProtectionNewsService from "src/modules/data-protection/apis/NewsService";
import AIRiskAssessmentModal from "src/modules/data-protection/components/RisksAndTasks/risks/ai/AssessmentModal";
import FindingDetailBody from './components/finding';
import {
    CHAT_BOT_DOMAIN,
    API_URL_RISK_AI_GET_ADDITIONAL_DETAILS,
    API_BASE_URL
} from 'src/modules/data-protection/constants';

const FindingDetails = function (props) {
    const { softwareId } = useParams();
    const {
        organization,
        t,
        assetId,
        finding: {
            id
        }
    } = props;

    const history = useHistory();

    const [aiBasedRiskAssessmentModalStatus, setAiBasedRiskAssessmentModalStatus] = useState(false);

    const {
        data: finding,
        isLoading: findingDetailsIsLoading,
        isFetching: findingDetailsIsFetching
    } = useQuery({
        queryKey: [
            'gdpr-fetch-finding-details',
            assetId,
            id
        ],
        queryFn: async () => {
            const service = DataProtectionNewsService.getInstance();

            return await service.details(id);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t('Sorry, there was an issue loading the news details. Please try again.'), {
                type: 'error',
            });
        },
    });

    const renderLoadingPlaceholder = () => {
        return (
            <Row>
                <Col sm="12" md="9">
                    <div className="dt-field dt-skeleton mb-4" style={{ width: '70%' }}></div>
                    <div className="dt-field dt-skeleton mb-5" style={{ width: '50%', height: '220px' }}></div>

                    <div className="dt-field dt-skeleton mb-1" style={{ width: '90%' }}></div>
                    <div className="dt-field dt-skeleton mb-1" style={{ width: '85%' }}></div>
                    <div className="dt-field dt-skeleton mb-1" style={{ width: '90%' }}></div>
                    <div className="dt-field dt-skeleton mb-4" style={{ width: '50%' }}></div>

                    <div className="dt-field dt-skeleton mb-1" style={{ width: '90%' }}></div>
                    <div className="dt-field dt-skeleton mb-1" style={{ width: '85%' }}></div>
                    <div className="dt-field dt-skeleton mb-1" style={{ width: '90%' }}></div>
                    <div className="dt-field dt-skeleton mb-4" style={{ width: '50%' }}></div>

                    <div className="dt-field dt-skeleton mb-1" style={{ width: '90%' }}></div>
                    <div className="dt-field dt-skeleton mb-1" style={{ width: '85%' }}></div>
                    <div className="dt-field dt-skeleton mb-1" style={{ width: '90%' }}></div>
                    <div className="dt-field dt-skeleton" style={{ width: '50%' }}></div>
                </Col>

                <Col sm="12" md="3">
                    <div className="dt-field dt-skeleton w-100 mb-4" style={{ height: '220px' }}></div>
                    <div className="dt-field dt-skeleton w-100 mb-4" style={{ height: '220px' }}></div>
                    <div className="dt-field dt-skeleton w-100" style={{ height: '220px' }}></div>
                </Col>
            </Row>
        );
    }

    const renderModals = () => {
        return (
            aiBasedRiskAssessmentModalStatus && (
                <AIRiskAssessmentModal
                    closeModal={() => setAiBasedRiskAssessmentModalStatus(false)}
                    onRisksCreated={() => history.push({ search: '?tab=risk-assessment' })}
                    isOpen={aiBasedRiskAssessmentModalStatus}
                    translateResult={true}
                    aiRequestOptions={{
                        requestUrl: `${CHAT_BOT_DOMAIN}api/gdpr/news-software-asset-risks.get`,
                        payload: {
                            module: 'GDPR_NEWS_SOFTWARE_ASSET',
                            organizationId: organization.id,
                            newsMonitoringAssetId: id,
                        }
                    }}
                    aiTranlateRequestOptions={{
                        requestUrl: `${CHAT_BOT_DOMAIN}api/gdpr/risks-associated-news-asset.get`,
                        payload: {
                            module: "GDPR_NEWS_SOFTWARE_ASSET",
                            organizationId: organization.id,
                            findingId: id
                        }
                    }}
                    additionnalDetailsRequestOptions={{
                        requestUrl: API_URL_RISK_AI_GET_ADDITIONAL_DETAILS,
                        payload: {}
                    }}
                    createRisksRequestOptions={{
                        requestUrl: `${API_BASE_URL}/risk_rate/create_ai`,
                        payload: { software: softwareId }
                    }}
                >
                    {(result) => {
                        return (
                            <Modal className="ai-risk-result-modal mw-100" style={{ width: '90%' }} isOpen={aiBasedRiskAssessmentModalStatus} size="xl">
                                <ModalHeader toggle={() => setAiBasedRiskAssessmentModalStatus(!aiBasedRiskAssessmentModalStatus)}>
                                    {t('Risk Assesment Support by AI')}
                                </ModalHeader>
                                <ModalBody>
                                    <result.type {...result.props} />
                                </ModalBody>
                            </Modal>
                        )
                    }}
                </AIRiskAssessmentModal>
            )
        )
    }

    const renderFindingBody = () => {
        return (
            <FindingDetailBody
                setAiBasedRiskAssessmentModalStatus={setAiBasedRiskAssessmentModalStatus}
                finding={finding}
            />
        );
    }

    const isLoading = findingDetailsIsLoading || findingDetailsIsFetching;

    return (
        <div className="finding-details-content p-2">
            {
                (isLoading) ? (
                    <>{renderLoadingPlaceholder()}</>
                ) : (
                    <>
                        {renderFindingBody()}
                        {renderModals()}
                    </>
                )
            }
        </div>
    )
};

const mapStatetoProps = (state) => {
    const { Organization } = state;
    const { token } = state.Login;

    return {
        user: state.Login.user,
        organization: Organization,
        token
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {}
    )(FindingDetails)
);